import { Routes, Route } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Home from './pages/Home'
import Cropper from './pages/Cropper'
import Privacy from './pages/Privacy'
import FAQ from './pages/FAQ'
import NotFound from './pages/NotFound'
import { supportedLocales, defaultLocale } from './i18n'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <AnimatePresence mode="wait">
          <Routes>
            {/* English routes (default) */}
            <Route path="/" element={<Home />} />
            <Route path="/cropper" element={<Cropper />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/faq" element={<FAQ />} />

            {/* Localized routes for all supported non-default locales */}
            {supportedLocales
              .filter((locale) => locale !== defaultLocale)
              .map((locale) => (
                <Route key={locale} path={`/${locale}`} element={<Home />} />
              ))}
            {supportedLocales
              .filter((locale) => locale !== defaultLocale)
              .map((locale) => (
                <Route key={`${locale}-cropper`} path={`/${locale}/cropper`} element={<Cropper />} />
              ))}
            {supportedLocales
              .filter((locale) => locale !== defaultLocale)
              .map((locale) => (
                <Route key={`${locale}-privacy`} path={`/${locale}/privacy`} element={<Privacy />} />
              ))}
            {supportedLocales
              .filter((locale) => locale !== defaultLocale)
              .map((locale) => (
                <Route key={`${locale}-faq`} path={`/${locale}/faq`} element={<FAQ />} />
              ))}

            {/* 404 page */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AnimatePresence>
      </main>
      <Footer />
    </div>
  )
}

export default App
